import React, { useEffect, useState, useMemo, useCallback } from 'react';
import { useSelector } from 'react-redux';

import {
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  Typography,
} from '@material-ui/core';

import { isEmpty } from 'lodash';

import { differenceBy, concat, get, assign } from 'lodash';

import { Table } from '~/components';

import { ADM } from '~/constants/perfil';

import { Container } from './styles';
import * as S from './styles';

export default function DadosUnidade({ data }) {
  const { profile } = useSelector((state) => state.user);

  const [bloqueado, setBloqueado] = useState(false);
  useEffect(() => {
    // if (!isEmpty(data)) {
    //   setBloqueado(data.unidade.unid_bloqueio_inadimplencia === 'S');
    // }
  }, [data]);

  const [clearCheckeds, setClearCheckeds] = useState(false)

  const [rowsDisponiveis, setRowsDisponiveis] = useState(data.rowsDisponiveis);
  const [rowsSelecionadas, setRowsSelecionadas] = useState(data.rowsSelecionadas);

  const [loading, setLoading] = useState(false);

  const handleRuleStyle = useCallback((data) => {
    if (data.unid_codigo === 'admin') {
      return {
        color: '#fff',
        background: '#096',
      };
    }
    return undefined;
  }, []);

  const handleFormatValue = useCallback((value) => {
    if (value === 'L') return 'Liberado';
    return 'Bloqueado';
  }, []);

  const HandleAddItems = useCallback((arrayData) => {
    // const objSend = {
    //   ...data,
    //   rowsDisponiveis: differenceBy(data.rowsDisponiveis, arrayData, 'unid_codigo'),
    //   rowsSelecionadas: concat(data.rowsSelecionadas, arrayData),
    // };
    // setData(objSend);  
    setClearCheckeds(false)
    const arrayDisponiveis = differenceBy(rowsDisponiveis, arrayData, 'unid_codigo');
    const arraySelecionado = concat(rowsSelecionadas, arrayData);
    data.rowsDisponiveis = arrayDisponiveis; //differenceBy(data.rowsDisponiveis, arrayData, 'unid_codigo');
    data.rowsSelecionadas = arraySelecionado; //concat(data.rowsSelecionadas, arrayData);    
    setRowsDisponiveis(arrayDisponiveis);
    setRowsSelecionadas(arraySelecionado);
  }, [data, rowsDisponiveis, rowsSelecionadas]);


  const HandleRemoveItem = useCallback((arrayData) => {
    // const objSend = {
    //   ...data,
    //   rowsDisponiveis: concat(data.rowsDisponiveis, arrayData),
    //   rowsSelecionadas: differenceBy(data.rowsSelecionadas, arrayData, 'unid_codigo'),
    // };
    // setData(objSend);
    setClearCheckeds(true)
    const arrayDisponiveis = concat(rowsDisponiveis, arrayData);
    const arraySelecionado = differenceBy(rowsSelecionadas, arrayData, 'unid_codigo');
    data.rowsDisponiveis = arrayDisponiveis; //concat(data.rowsDisponiveis, arrayData);
    data.rowsSelecionadas = arraySelecionado; //differenceBy(data.rowsSelecionadas, arrayData, 'unid_codigo');    
    setRowsDisponiveis(arrayDisponiveis);
    setRowsSelecionadas(arraySelecionado);
  }, [data, rowsDisponiveis, rowsSelecionadas]);


  useEffect(() => {
    console.log(rowsDisponiveis)
  }, [rowsDisponiveis])


  const headerUnidades = useMemo(
    () => [
      {
        id: 'unid_nome',
        label: 'Unidades',
        style: handleRuleStyle,
      },
      {
        id: 'unid_codigo',
        label: 'Código',
        align: 'center',
      },
    ],
    []
  );


  return (
    <>
      <S.Wrapper>
        <Table
          showCount
          search
          title="Unidades disponíveis"
          checkbox
          cells={headerUnidades}
          clearCheckeds={clearCheckeds}
          data={rowsDisponiveis}
          height="20rem"
          size="small"
          loading={loading}
          onCallback={(values) => HandleAddItems(values)}
          unique="unid_codigo"
          labelButton="Adicionar"
        />


        <Table
          showCount
          search
          checkbox
          title="Unidades selecionadas"
          cells={headerUnidades}
          //data={data.rowsSelecionadas}
          data={rowsSelecionadas}
          height="20rem"
          size="small"
          onCallback={(values) => HandleRemoveItem(values)}
          unique="unid_codigo"
          labelButton="Remover"
        />
      </S.Wrapper>
    </>
  );
}
